import { Modal, ModalBody } from 'reactstrap';
import { useRecoilValue } from 'recoil';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-hot-toast';
import { map } from 'lodash';

import { useCollaboratorsActions } from '../../../../services/actions/collaborators.actions';
import { bulkLoadAtom } from '../../../../services/atoms/collaborators.atoms';
import { ButtonLoading } from '../../../../components/buttons/button-loading';
import DropzoneComponent from './dropzone-component';
import { HOST_GROWME } from '../../../../helpers/constants';
import CollaboratorsAPI from '../../../../services/api/collaborators.api';
import { ErrorIcon } from '../../../../assets/icons';

const BulkLoadModal = (props) => {
  const { open, toggle, clientId, pageMeta, handleOpenModal, setErrorsModal, update} = props;
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps
  } = useDropzone({
    validator: customFileValidator
  });
  const { bulkLoad, collaboratorsList, templateExcel } = useCollaboratorsActions();
  const bulkResolver = useRecoilValue(bulkLoadAtom);

  const handleSubmit = (e) => {
    e.preventDefault();
    let formdata = new FormData();
    formdata.append("clientId", clientId);
    map(acceptedFiles, (file) => formdata.append("file", file));
    bulkLoad(formdata, (res) => {
      if (res?.status === 200){
        toast.success('Colaboradores cargados exitosamente');
        // collaboratorsList({ page: pageMeta.page, limit: pageMeta.limit, clientId });
        toggle();
        update();
        return;
      } else if(res?.response?.data.length >0) {
        setErrorsModal(res?.response?.data || [])
        toggle();
        handleOpenModal();
        return;
      } else if(res?.response?.status ===400 ||res?.response?.status === 500){
        toast.error('Se ha encontrado un error en el archivo Excel', {duration:4000})
      }
    });
  }

  const handleDownloadTemplate = async () => {
    try {
      const response = await fetch(`${HOST_GROWME}/collaborators/excel`);
      if (!response.ok) {
        throw new Error('Error al descargar la plantilla');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Carga masiva colaboradores-GrowMe.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error(error);
      return;
    }
  };

  function customFileValidator(file) {
    const allowedExtensions = ['.xls', '.xlsx']; 
    const maxFileSize = 10 * 1024 * 1024;
    const fileExtension = `.${file?.name?.split('.').pop()?.toLowerCase()}`;
  
    if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
      return {
        code: "Error de Carga",
        message: `La carga no se ha podido completar por error de formato del archivo. Extensiones permitidas: ${allowedExtensions.join(', ')}.`,
      };
    } else if (file.size > maxFileSize) {
      return {
        code: "Error de Carga",
        message: "Archivo excede el límite máximo permitido de 10MB",
      };
    }
    return null;
  }
  

const fileRejectionItems = fileRejections.map(({ file, errors }) => (
  <div className='' key={file.path}>
    <div>
      {errors.map(e => (
      <div>
      <div className="gm-modal-header-bulk-load">
        <div className="gm-modal-title-container">
          <div className="gm-modal-title"><ErrorIcon /> Error de Carga</div>
        </div>
        <li className='gm-modal-bulk-load-error' key={e.code}>{e.message}</li>
      </div>
        </div>
      ))}
    </div>
  </div>
));


return (
<>
<Modal isOpen={open} toggle={toggle}>
      <div className='gm-modal-header'>
        <div className='gm-modal-title-container'>
          <div className='gm-modal-title'>Cargar Datos de Colaboradores</div>
        </div>
        <button type="button" className="btn-close" aria-label="Close" onClick={toggle} />
      </div>

      <ModalBody>
        <form onSubmit={handleSubmit}>
        <div className='gm-modal-instructions-container'>
          <ul>
            <span>¿Cómo cargo masivamente mis colaboradores?</span>
            <li> Descarga la<button type='button' className='gm-none-button' onClick={handleDownloadTemplate}>Plantilla de Ejemplo.</button> </li>
            <li>Rellena los campos con el formato demostrado. <br></br> (Campos obligatorios en <span>rojo</span>)</li>
            <li>Elimina la fila de ejemplo</li>
            <li>Sube tu archivo completo</li>
          </ul>
       
      </div>
          <div className='gm-modal-form-container'>
            <div className='gm-bulk-container'>
              <DropzoneComponent
                acceptedFiles={acceptedFiles}
                getRootProps={getRootProps}
                getInputProps={getInputProps}
                fileRejectionItems={fileRejectionItems}
              />
            </div>
          </div>
          <div>
          </div>
          <div className='gm-modal-buttons'>
            <button type='button' className='gm-secondary-button' onClick={toggle}>
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel='Subir archivo'
              disabled={bulkResolver.loading || fileRejectionItems.length !== 0}
              loading={bulkResolver.loading}
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
</>
  );
}

export default BulkLoadModal;